import React, { useEffect } from 'react';
import { useTrackingContext } from './TrackingContext';
import { WidgetTrackingData } from 'shared/components/AdPlatformWidgets/types';

interface ITracking {
  widgetRef: React.RefObject<HTMLElement>;
  trackingData?: WidgetTrackingData;
  doTracking?: boolean;
}

export const useTrackingObserver = ({ widgetRef, trackingData, doTracking = true }: ITracking) => {
  const { attachObserver, detachObserver, onWidgetClick } = useTrackingContext();

  useEffect(() => {
    let nodeRef: HTMLElement | undefined;
    if (doTracking === false || widgetRef.current === null || trackingData === undefined) {
      return;
    }

    nodeRef = widgetRef.current;

    attachObserver(widgetRef.current, trackingData);

    return () => {
      if (!nodeRef) {
        return;
      }

      detachObserver(nodeRef);
    };
  }, [attachObserver, detachObserver, doTracking, widgetRef, trackingData]);

  return { onWidgetClick };
};
